import {
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import { sortableKeyboardCoordinates } from '@dnd-kit/sortable';

/**
 * Custom hook providing standard sensor configuration for drag-and-drop sorting.
 * Configures PointerSensor with activation distance and KeyboardSensor with sortable coordinates.
 *
 * The PointerSensor requires 3px movement before activating drag, preventing accidental drags
 * while still providing an immediate, responsive feel similar to Google Forms.
 *
 * @returns Configured sensors for use with DndContext
 *
 * @example
 * const sensors = useSortableSensors();
 * return (
 *   <DndContext sensors={sensors} ...>
 *     ...
 *   </DndContext>
 * );
 */
export function useSortableSensors() {
  return useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 3, // Require 3px movement before drag starts - responsive but prevents accidents
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );
}

export default useSortableSensors;
